import React from "react";
export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const data = this.props.data;
    
    const printStyles = {
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #000'
      },
      th: {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'left',
        backgroundColor: '#f2f2f2',
        fontWeight: 'bold'
      },
      td: {
        border: '1px solid #000',
        padding: '8px'
      },
      tdRight: {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'right'
      },
      statusPending: {
        border: '1px solid #000',
        padding: '8px',
        backgroundColor: '#ff9800',
        color: '#000'
      },
      statusApproved: {
        border: '1px solid #000',
        padding: '8px',
        backgroundColor: '#4caf50',
        color: '#000'
      },
      statusRejected: {
        border: '1px solid #000',
        padding: '8px',
        backgroundColor: '#f44336',
        color: '#000'
      }
    };

    const getStatusStyle = (statusID) => {
      if (statusID === 1) return printStyles.statusPending;
      if (statusID === 2) return printStyles.statusApproved;
      if (statusID === 3) return printStyles.statusRejected;
      return printStyles.td;
    };

    const getStatusText = (statusID) => {
      if (statusID === 1) return "Pending";
      if (statusID === 2) return "Approved";
      if (statusID === 3) return "Rejected";
      return "";
    };

    return (
      <div>
        <style>
          {`
            @media print {
              table {
                border-collapse: collapse !important;
                width: 100% !important;
              }
              th, td {
                border: 1px solid #000 !important;
                padding: 8px !important;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              th {
                background-color: #f2f2f2 !important;
              }
            }
          `}
        </style>
        <h3>
          <center>
            <u>Worked Inactive Employee Report</u>
          </center>
        </h3>
        <div className="row pl-2 pb-4 pt-4">
          <div className="col">
            <b>Group: </b> {searchData.group}
          </div>
          <div className="col">
            <b>Operation Entity: </b> {searchData.estate}
          </div>
          <div className="col">
            <b>Collection Point: </b> {searchData.division}
          </div>
          <div className="col">
            <b>From Date: </b> {searchData.fromDate}
          </div>
          <div className="col">
            <b>To Date: </b> {searchData.toDate}
          </div>
        </div>
        <div>
          <table style={printStyles.table}>
            <thead>
              <tr>
                <th style={printStyles.th}>Date</th>
                <th style={printStyles.th}>Registered Division</th>
                <th style={printStyles.th}>Worked Division</th>
                <th style={printStyles.th}>Employee Number</th>
                <th style={printStyles.th}>Employee Name</th>
                <th style={printStyles.th}>Work Type</th>
                <th style={printStyles.th}>Operator</th>
                <th style={printStyles.th}>Job Code</th>
                <th style={printStyles.th}>Work Qty</th>
                <th style={printStyles.th}>Man Day</th>
                <th style={printStyles.th}>OT</th>
                <th style={printStyles.th}>Estate Management's Review</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td style={printStyles.td}>{row.date ? row.date.split("T")[0] : ""}</td>
                  <td style={printStyles.td}>{row.registerdDivision}</td>
                  <td style={printStyles.td}>{row.workedDivision}</td>
                  <td style={printStyles.td}>{row.employeeNumber}</td>
                  <td style={printStyles.td}>{row.employeeName}</td>
                  <td style={printStyles.td}>{row.workType}</td>
                  <td style={printStyles.td}>{row.operator}</td>
                  <td style={printStyles.td}>{row.jobCode}</td>
                  <td style={printStyles.tdRight}>{row.workQty}</td>
                  <td style={printStyles.tdRight}>{row.manDay}</td>
                  <td style={printStyles.tdRight}>{row.ot}</td>
                  <td style={getStatusStyle(row.employeeApprovelStatusID)}>
                    {getStatusText(row.employeeApprovelStatusID)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}